export default "__VITE_ASSET__1fe583fb__"